package com.eladfinish.bible.contest.platform.share

import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.appcontent.AppLinks
import com.eladfinish.bible.contest.data.common.AssetReader
import com.eladfinish.bible.contest.data.common.DocumentTextType
import com.eladfinish.bible.contest.extensions.formatString
import com.eladfinish.bible.contest.shareTextHtml_txt
import com.eladfinish.bible.contest.shareText_txt

class ShareTextFormatter {

    fun format(
        assetReader: AssetReader,
        documentTextType: DocumentTextType = DocumentTextType.TXT,
    ): String {
        return assetReader.readFile(
            when (documentTextType) {
                DocumentTextType.TXT -> SharedRes.assets.other.shareText_txt
                // PDFs are rendered from HTML, so they share the HTML footer.
                DocumentTextType.HTML, DocumentTextType.PDF -> SharedRes.assets.other.shareTextHtml_txt
            }
        ).withStoreLinks(campaign = ShareCampaign.DOCUMENT_FOOTER)
    }
}

/** Which share a Play link came from — its `utm_campaign`, as Firebase reports it (`firstUserCampaignName`). */
object ShareCampaign {
    const val SHARE_APP = "share_app"
    const val DOCUMENT_FOOTER = "document_footer"
}

/**
 * The Play link in texts the app shares. Installs through it show up in Firebase as
 * `app / share / <campaign>` instead of blending into `google-play / organic`.
 */
fun sharedPlayStoreUrl(campaign: String): String =
    AppLinks.playStoreUrl(source = "app", medium = "share", campaign = campaign)

/**
 * Fills the share-text assets' `%s` placeholders — the Play Store URL, then the App Store URL — from
 * [AppLinks], so the assets don't keep their own copy of the store links. A template that only
 * links to one store simply ignores the extra argument.
 */
fun String.withStoreLinks(campaign: String): String = formatString(sharedPlayStoreUrl(campaign), AppLinks.APP_STORE_URL)
